export default "./images/survio-3FIYZ-reference-sv.png";